/* eslint-disable no-param-reassign */
import RequestUrls from '@Constants/RequestUrlsConstants';
import MessageBroker from '@Services/MessageBroker';
import get from 'lodash/get';

const saveForm = (displayName, content) => MessageBroker.send(RequestUrls.saveForm, { displayName, content }, { cache: false });

const editForm = (formId, displayName, content) =>
  MessageBroker.send(RequestUrls.editForm, { formId, displayName, content }, { cache: false });

const deleteForm = (formId) => MessageBroker.send(RequestUrls.deleteForm, { formId }, { cache: false });

const clearValues = (form) => {
  const facts = get(form, 'facts', []);
  const fields = get(form, 'fields', []);
  const structures = get(form, 'structures', []);

  facts.forEach((fact) => clearValues(fact));

  // eslint-disable-next-line no-return-assign
  fields.forEach((field) => (field.value = ''));

  structures.forEach((structure) => {
    structure.options = [];
    structure.structure = null;
  });

  if (form && !form.fieldsLogicOperator) {
    form.fieldsLogicOperator = 'PROXIMITY';
    form.exist = false;
  }
};

export { saveForm, editForm, deleteForm, clearValues };
